import DomParser from 'dom-parser';

/**
 * creates a message event listener for a datawrapper embed
 *
 * @param {string} src the embed url of the datawrapper embed
 * @param {function} updateStyles update callback, should retrieve an react style object
 */
const createDataWrapperListener = (src, updateStyles) => (event) => {
    if (typeof event.data['datawrapper-height'] !== 'undefined') {
        for (let chartId in event.data['datawrapper-height']) {
            if (src.indexOf(chartId) !== -1) {
                const height = event.data['datawrapper-height'][chartId];
                updateStyles({height: `${height}px`});
            }
        }
    }
};

/**
 * parses an embed code for width/height properties to try to extract an aspect ratio
 * this is mainly for legacy import support (iframe handling was complicated)
 *
 * @param {string} embedCode html embed code to parse
 */
const getAspectRatio = (embedCode) => {
    if (embedCode) {
        const parser = new DomParser();
        const doc = parser.parseFromString(embedCode);
        const iframe = doc.getElementsByTagName('iframe')[0];

        if (iframe) {
            const {height, width = '600'} = iframe.attributes.reduce((attributes, attribute) => {
                attributes[attribute.name] = attribute.value;

                return attributes;
            }, {});

            if (height) {
                const pixelWidth = width === '100%' ? 600 : parseInt(width, 10);
                const pixelHeight = parseInt(height, 10);
                return pixelWidth / pixelHeight;
            }
        }
    }

    return 16 / 9;
};

export {createDataWrapperListener, getAspectRatio};
